import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

import AccountPanel from '../account/AccountPanel';
import { useSelection } from '../selection/SelectionContext';
import WalletActionsModal from '../wallet/WalletActionsModal';

export default function HomePage() {
  const { networksError, provisionError, retryNetworks } = useSelection();
  const [walletOpen, setWalletOpen] = useState(false);

  return (
    <Stack spacing={2.5}>
      {networksError ? (
        <Alert
          severity="error"
          action={
            <Typography
              component="button"
              onClick={retryNetworks}
              sx={{
                background: 'none',
                border: 0,
                font: 'inherit',
                fontWeight: 700,
                color: 'inherit',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              Retry
            </Typography>
          }
        >
          Could not load networks: {networksError}
        </Alert>
      ) : null}

      {provisionError ? (
        <Alert severity="warning">Wallet provisioning failed: {provisionError}</Alert>
      ) : null}

      <Button
        variant="contained"
        fullWidth
        onClick={() => setWalletOpen(true)}
        sx={{ height: 52, fontSize: 16 }}
      >
        Deposit / Withdraw
      </Button>

      <AccountPanel />

      <WalletActionsModal open={walletOpen} onClose={() => setWalletOpen(false)} />
    </Stack>
  );
}
